$(document).on('change', '#custom1', function(){
  let firstField = $(this).val();
  console.log(firstField);
  $('#custom1_1').val(firstField);
});

$(document).on('change', '#custom2', function(){
  let firstField = $(this).val();
  console.log(firstField);
  $('#custom2_2').val(firstField);
});


//collection slider
var swiper = new Swiper(".custom-collection-sldier-swiper", {
    slidesPerView:3.4,
    spaceBetween: 20,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: 1.2,
                spaceBetween: 20,
                slideToClickedSlide: true,
            },
            // when window width is >= 640px
            640: {
                slidesPerView: 3.4,
                spaceBetween: 20,
                slideToClickedSlide: true,
            }
          
      
        }
});

$('.swiper-button-next-custom').click(function(){
  $('.swiper-button-next').trigger('click');
});
$('.swiper-button-prev-custom').click(function(){
  $('.swiper-button-prev').trigger('click');
});

//hpme product slider
var swiper = new Swiper(".custom-collection-sldier-swiper2", {
    slidesPerView:3.4,
    spaceBetween: 20,
    navigation: {
      nextEl: ".swiper-button-next2",
      prevEl: ".swiper-button-prev2",
    },
    breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: 1.2,
                spaceBetween: 20,
                slideToClickedSlide: true,
            },
            // when window width is >= 640px
            640: {
                slidesPerView: 3.4,
                spaceBetween: 20,
                slideToClickedSlide: true,
            }
        }
});
$('.swiper-button-next-custom2').click(function(){
  $('.swiper-button-next2').trigger('click');
});
$('.swiper-button-prev-custom2').click(function(){
  $('.swiper-button-prev2').trigger('click');
});

//light scroll
var $page = $('html, body');
$('a[href*="#"]').click(function() {
    $page.animate({
        scrollTop: $($.attr(this, 'href')).offset().top
    }, 400);
    return false;
});


// $('.footer-block--menu').each(function(){
//   let a = $(this).find('h2').text();
//   if(a === 'QUICK LINKS'){
//     $(this).addClass('with-dashboard');
//   }
// })

  

$(()=>{

});
